import * as React from "react";
const SvgFiRrTireFlat = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-tire-flat_svg__a)">
      <path
        fill="#062147"
        d="M21.566 19.229c6-7.7.2-19.354-9.566-19.229C2.286-.176-3.583 11.59 2.44 19.235A2.51 2.51 0 0 0 3.5 24h17a2.513 2.513 0 0 0 1.066-4.771M20.5 22h-17a.5.5 0 1 1 .053-1 1.45 1.45 0 0 0 1.416-1c.162-.638-.224-1.1-.672-1.633C-1.1 12.017 3.669 1.9 12 2c8.357-.094 13.12 10.045 7.662 16.411-.41.487-.795.947-.631 1.583A1.475 1.475 0 0 0 20.5 21a.5.5 0 0 1 0 1M12 4a8.01 8.01 0 0 0-8 8c.376 10.588 15.626 10.585 16 0a8.01 8.01 0 0 0-8-8m-.834 9.086a4.2 4.2 0 0 0-.444-1.577c.482-.19.918-.482 1.278-.856q.264.276.58.49.33.222.7.366c-.249.492-.4 1.027-.441 1.577a4.1 4.1 0 0 0-1.673 0m5.954-4.212-1.426.571-.5.2A1.6 1.6 0 0 1 13 8.163V6.084a6.02 6.02 0 0 1 4.12 2.79M11 6.084v2.079a1.6 1.6 0 0 1-2.19 1.483l-1.93-.772A6.02 6.02 0 0 1 11 6.084M6 12q0-.642.135-1.269l1.7.681a2.128 2.128 0 0 1 .917 3.249l-1.1 1.469A5.98 5.98 0 0 1 6 12m3.25 5.332L10.4 15.8a2.058 2.058 0 0 1 3.2 0l1.148 1.532a6.04 6.04 0 0 1-5.497 0m7.1-1.2-1.1-1.464a2.128 2.128 0 0 1 .915-3.255l1.7-.681a6.03 6.03 0 0 1-1.517 5.399z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-tire-flat_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrTireFlat;
